import {Injectable, InjectionToken} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

import {ApiRoutes} from '../../../common/api-routes';
import {PayType2Map, PayCode} from '../../../common/pay-code.model';

export interface IPayCodeService {
  RetrievePayType2Map(): Observable<PayType2Map>;
  RetrieveAllPayCodes(): Observable<PayCode[]>;
}

export const PayCodeServiceToken = new InjectionToken<IPayCodeService>('IPayCodeService');

@Injectable()
export class UsPayCodeService implements IPayCodeService {
  constructor(private _http: HttpClient) {}

  RetrievePayType2Map(): Observable<PayType2Map> {
    return this._http.get<PayType2Map>(`${ApiRoutes.PayCodes}/payType2`);
  }

  RetrieveAllPayCodes(): Observable<PayCode[]> {
    return this._http.get<PayCode[]>(`${ApiRoutes.PayCodes}/all`);
  }
}

@Injectable()
export class UkPayCodeService implements IPayCodeService {
  constructor(private _http: HttpClient) {}

  RetrievePayType2Map(): Observable<PayType2Map> {
    return this._http.get<PayType2Map>(`${ApiRoutes.PayCodes}/regions/uk/payType2`);
  }

  RetrieveAllPayCodes(): Observable<PayCode[]> {
    return this._http.get<PayCode[]>(`${ApiRoutes.PayCodes}/regions/uk/all`);
  }
}
